import { render, staticRenderFns } from "./AnnouncementModal.vue?vue&type=template&id=4452999f&scoped=true"
import script from "./AnnouncementModal.vue?vue&type=script&lang=js"
export * from "./AnnouncementModal.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementModal.vue?vue&type=style&index=0&id=4452999f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4452999f",
  null
  
)

export default component.exports